/**
 * Created by mykurisu on 2017/10/13.
 */
import React from 'react'
import {setToken, getJsonFromUrl} from '../utils'


class WeikeDoor extends React.Component {

    componentDidMount() {
        let params = getJsonFromUrl();
        let token = params.__token;
        if (token) {
            setToken(token);
            window.location.replace('/')
        }
    }

    render() {
        return null
    }

}

export default WeikeDoor



// WEBPACK FOOTER //
// ./src/pages/WeikeDoor.js